import {useTranslation} from "@Translation/hooks/useTranslation";
import {
    singleModalTranslationKey
} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";

interface HowToContentProps {
    departure: string,
    destination: string,
    availableTransportation: string
}

function HowToContent({departure, destination, availableTransportation}: HowToContentProps) {
    const title = useTranslation(
        `${singleModalTranslationKey}.how_to.title`,
        {departure, destination}
    )

    const content = useTranslation(
        `${singleModalTranslationKey}.how_to.description`,
        {departure, destination, availableTransportation}
    )

    return (
        <TitleAndContent
            title={title}
            content={content}
        />
    )
}

export default HowToContent